/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import {
  Col,
  Row,
  Skeleton,
  // DatePicker,
  Table,
  // Select,
  AutoComplete,
  Input,
 // Spin,
  Space,
  Button,
  Checkbox,
  Modal,
  Tooltip,
  Drawer,
  Typography,
  Card,
//  Radio,
  Select,
  // Collapse,
  // Button,
} from "antd";
import "../index.css";
import {
  CloseOutlined,
  DeleteOutlined,
//  DownloadOutlined,
  DownOutlined,
  ExclamationCircleOutlined,
  PlusOutlined,
  UpOutlined,
} from "@ant-design/icons";
import {
  //BiCalendar,
  BiCheckbox,
  BiCheckboxChecked,
  // BiLock,
  // BiLockOpen,
} from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
//import moment from "moment";
import { isEmpty } from "lodash";
import useMedia from "use-media-antd-query";
import api from "../../../helpers";
import toast from "react-hot-toast";
import { FaRegEdit } from "react-icons/fa";
import {
  loadAccessList,
  loadMenuList,
  loadUserPermissionList,
  loadUserRoleList,
} from "../../../store/purchase-orders/actions";
import { Collapse, Divider} from "@mui/material";
import SimpleReactValidator from "simple-react-validator";

const UserPermissionDetails = (props) => {
  const dispatch = useDispatch();

  const media = useMedia();
  //Validations
  const simpleValidator = React.useRef(new SimpleReactValidator());
  const [, forceUpdate] = React.useState();
  //initial state values
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  // const [downloadLoading, setDownloadLoading] = useState(false);
  // const [organizationId, setOrganizationId] = useState({
  //   _id: "",
  //   status: "",
  // });
  // const [pageValue, setPageValue] = useState({
  //   page: "",
  //   pageSize: "",
  // });
  const [confirmationModal, setConfirmationModal] = useState(false);

  // const orgPayload = {
  //   page: pageValue && pageValue.page ? pageValue.page : 1,
  //   limit: pageValue && pageValue.pageSize ? pageValue.pageSize : 10,
  // };
  useEffect(() => {
    setLoading(true);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
      setLoading(false);
    }, 2000);
    dispatch(loadAccessList());
    dispatch(loadUserPermissionList());
    dispatch(loadMenuList());
    dispatch(loadUserRoleList());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reducer state
  const {
    access_list = [],
    user_permission_list = [],
    user_role_list = [],
    menu_list = [],
  } = useSelector((state) => state.PurchaseOrders);
  // state reducer

  const menuHeaderOptions =
    menu_list && menu_list.length > 0
      ? menu_list.filter((r) => r.menuType === "Menu Header") &&
        menu_list.filter((r) => r.menuType === "Menu Header")
      : [];

  const menuSubHeaderOptions =
    menu_list && menu_list.length > 0
      ? menu_list.filter((r) => r._id === "Menu Sub Header").menu
      : [];
  // const menuItemFilterOptions =
  //   menu_list &&
  //   menu_list.length > 0 &&
  //   menu_list.filter((r) => r._id === "menuItem")
  //     ? menu_list.filter((r) => r._id === "menuItem") &&
  //       menu_list.filter((r) => r._id === "menuItem").menu
  //     : [];

  const accessList =
    access_list.length > 0
      ? access_list.map((data, index) => {
          return {
            sNo: index + 1,
            _id: data._id,
            accessName: data.accessName,
            isDefault: data.isDefault,
            description: data.description,
            shortCode: data.shortCode,
            status: data.status,
            key: index,
          };
        })
      : [];

  const userRoleOptions =
    user_role_list && user_role_list.length > 0
      ? user_role_list.map((data) => {
          return {
            value: data._id,
            label: data.roleName,
          };
        })
      : [];
  //header columns
  const HeaderData = [
    {
      key: "roleName",
      title: <p className="font-label text-[13px] font-semibold">Role Name</p>,
      dataIndex: "roleName",
      width: 100,
      // fixed: "left",
      sorter: (a, b) => a.roleName.length - b.roleName.length,
    },
    {
      key: "description",
      title: (
        <p className="font-label text-[13px] font-semibold">Description</p>
      ),
      dataIndex: "description",
      width: 130,
    },
    {
      key: "status",
      title: <p className="font-label text-[13px] font-semibold">Status</p>,
      dataIndex: "status",
      width: 80,
    },
    {
      key: "action",
      title: <p className="font-label text-[13px] font-semibold">Action</p>,
      dataIndex: "action",
      width: 70,
    },
  ];

  // const escapeCSVField = (field) => {
  //   if (typeof field === "string" && field.includes(",")) {
  //     return `"${field}"`;
  //   }
  //   return field;
  // };

  //initial state for forms
  const [userRoleData, setUserRoleData] = useState({
    name: "",
    shortCode: "",
    _id: "",
    removeId: "",
    description: "",
  });
  //const [mode, setMode] = useState("");

  // const handleChange = (e) => {
  //   setUserRoleData({
  //     ...userRoleData,
  //     [e.target.name]: e.target.value,
  //   });
  // };
  //initial state
  const [userRoleId, setUserRoleId] = useState("");
  const [menuHeaderData, setMenuHeaderData] = useState([]);
//   const [menuSubHeaderData, setMenuSubHeaderData] = useState([]);
  // const [menuSubHeaderAccessData, setMenuSubHeaderAccessData] = useState([]);

  // const [menuItemsAccessData, setMenuItemsAccessData] = useState([]);
  // const [menuItemsData, setMenuItemsData] = useState([]);

  // const [selectedMenuId, setSelectedMenuId] = useState(null);
  const [selectedSubHeaders, setSelectedSubHeaders] = useState([]);
  const [selectedAccesses, setSelectedAccesses] = useState([]);
  // const [selectedMenu, setSelectedMenu] = useState(null);
  // const [removeRoleModal, setRemoveRoleModal] = useState(false);
  const [expandRowOpen, setExpandRowOpen] = useState(false);
//  const [expandRowSubHeaderOpen, setExpandRowSubHeaderOpen] = useState(false);

  const [expandRowId, setExpandRowId] = useState("");
 // const [expandRowSubHeadId, setExpandRowSubHeadId] = useState("");

  const [userRoleName, setUserRoleName] = useState([]);
  const [description, setDescription] = useState("");
  // const [roleCode, setRoleCode] = useState("");
  // const [isDefault, setIsDefault] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const onClose = () => {
    setOpen(false);
    setUserRoleName("");
    setDescription("");
   // setIsDefault(false);
  };

  //filters

//  const [filteredValues, setFilteredValues] = useState("");

  const [userRoleRows, setUserRoleRows] = useState([
    {
      _id: "",
      roleName: "",
      code: "",
      mode: "",
      descriptions: "",
      isDefault: "",
      status: "",
      action: "",
    },
  ]);

  const userRoleDataTable =
    !isEmpty(user_permission_list) && user_permission_list.length > 0
      ? user_permission_list.map((data) => {
          return {
            _id: data._id,
            roleName: data.roleName,
            mode: data.mode,
            code: data.code,
            description:
              data.description !== undefined ? data.description : "--",
            isDefault: (
              <div
                className={
                  data.isDefault === true
                    ? "text-[#08a35ae0] font-semibold text-start"
                    : "text-[#bb1d0d] font-semibold text-start"
                }
              >
                {data.isDefault === true ? "YES" : "NO"}
              </div>
            ),
            action: (
              <div className="flex">
                <Tooltip title={"Edit"} placement="top" className="mr-2">
                  <div
                    className={
                      "cursor-pointer rounded-sm bg-[#08a35ae0] px-[8px] py-[6px] hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label font-semibold text-start"
                    }
                    onClick={() => {
                      editUserRole(data);
                    }}
                  >
                    <FaRegEdit className="text-[14px]" />
                  </div>
                </Tooltip>
                <Tooltip title={"Delete"} placement="top">
                  <div
                    className={
                      "cursor-pointer rounded-sm bg-[#e74c3c] px-[8px] py-[6px] hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label font-semibold text-start"
                    }
                    onClick={() => {
                      setUserRoleId(data._id);
                      setConfirmationModal(true);
                    }}
                  >
                    <DeleteOutlined className="text-[14px]" />
                  </div>
                </Tooltip>
              </div>
            ),
            status: (
              <div
                className={
                  data &&
                  data.status &&
                  data.status.length > 0 &&
                  data.status[0].statusCode !== undefined &&
                  data.status[0].statusCode === 1
                    ? "w-[60%] flex justify-center cursor-pointer bg-[#08a35ae0] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#0b9b57e0] focus:bg-[#0b9b57e0] text-[white] font-label text-start"
                    : "w-[60%] flex justify-center cursor-pointer bg-[#e74c3c] pt-1 pb-1 pr-2 pl-2 rounded-sm hover:bg-[#bb1d0d] focus:bg-[#bb1d0d] text-[white] font-label text-start"
                }
              >
                {data &&
                data.status &&
                data.status.length > 0 &&
                data.status[0].statusCode !== undefined &&
                data.status[0].statusCode === 1
                  ? "Active"
                  : "Inactive"}
              </div>
            ),
          };
        })
      : [];

  useEffect(() => {
    if (userRoleDataTable && userRoleDataTable.length > 0) {
      setUserRoleRows(userRoleDataTable);
    } else {
      setUserRoleRows([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user_permission_list]);

  const getAccessNamesForMenu = (subHeader) => {
    return accessList.filter((access) =>
      subHeader.menuAccess.includes(access._id)
    );
  };

  console.log(selectedSubHeaders, "selectedSubHeaders");

  const permission = [];

  // 1. Process selected subheaders and their related accesses (and also child menu items)
  selectedSubHeaders?.forEach((subHeader) => {
    const subHeaderId = subHeader._id;
    const headerId = subHeader.headerMenu;

    // For the subheader level, include selected accesses
    const subHeaderAccessIds = selectedAccesses
      .filter((a) => a.subHeaderId === subHeaderId)
      .map((a) => a.accessId);

    if (subHeaderAccessIds.length > 0) {
      permission.push({
        headermenuId: headerId,
        menuId: subHeaderId,
        access: subHeaderAccessIds,
      });
    }

    // Also process menu items (child of the subheader) from your filter options
    // const relatedMenuItems = menuItemFilterOptions.filter(
    //   (item) => item.headerMenu === subHeaderId
    // );
    // relatedMenuItems.forEach((menuItem) => {
    //   const menuItemAccessIds = selectedAccesses
    //     .filter((a) => a.menuItemId === menuItem._id)
    //     .map((a) => a.accessId);
    //   if (menuItemAccessIds.length > 0) {
    //     permission.push({
    //       headermenuId: headerId,
    //       menuId: menuItem._id,
    //       access: menuItemAccessIds,
    //     });
    //   }
    // });
  });

  // 2. Process top-level headers (e.g., Dashboard)
  menuHeaderData?.forEach((header) => {
    const headerId = header._id;
    if (header.menuName?.toLowerCase() === "dashboard") {
      permission.push({
        headermenuId: headerId,
        menuId: headerId,
        access: [],
      });
    } else {
      const headerAccessIds = selectedAccesses
        .filter((a) => a.menuId === headerId)
        .map((a) => a.accessId);
      if (headerAccessIds.length > 0) {
        permission.push({
          headermenuId: headerId,
          menuId: headerId,
          access: headerAccessIds,
        });
      }
    }
  });

  // 3. NEW: Process selected menu items (child menu items of subheaders)
  // If a menu item is selected (exists in menuItemsData), push it with its accesses
  // Look up the parent subheader (from menuSubHeaderOptions) to get its header id.
  // menuItemsData?.forEach((menuItem) => {
  //   const menuItemAccessIds = menuItemsAccessData
  //     .filter((a) => a.menuItemId === menuItem._id)
  //     .map((a) => a.accessId);
  //   if (menuItemAccessIds.length > 0) {
  //     // Get parent subheader's id from menuItem.headerMenu, then lookup the parent header id
  //     const parentSubHeader = menuSubHeaderOptions.find(
  //       (sh) => sh._id === menuItem.headerMenu
  //     );
  //     const headerId = parentSubHeader ? parentSubHeader.headerMenu : null;
  //     if (headerId) {
  //       permission.push({
  //         headermenuId: headerId,
  //         menuId: menuItem._id,
  //         access: menuItemAccessIds,
  //       });
  //     }
  //   }
  // });

  const editUserRole = (data) => {
    console.log(data, "data");
    setUserRoleId(data._id);
    setUserRoleName({
      label: data.roleName,
      value: data.roleId,
    });
    // setIsDefault(data.isDefault);
    setDescription(data.description);
    setEditModal(true);
    setOpen(true);
    // Set basic role properties.
    setUserRoleData({
      description: data?.description,
      name: data?.name,
      shortCode: data?.shortCode,
      mode: data?.mode,
      _id: data?._id,
    });
  //  setMode(data?.mode);

    // Initialize arrays to accumulate the selected state.
    const updatedSelectedAccesses = [];
    const updatedSelectedSubHeaders = [];
    const updatedMenuHeaderData = [];

    // Get permissions from the role data.
    const permissions = Array.isArray(data?.permission) ? data.permission : [];

    permissions.forEach((perm) => {
      // Each permission object is expected to have:
      // { headermenuId, menuId, access: [array of access IDs] }
      const { headermenuId, menuId, access } = perm;

      // Ensure that the parent header is added.
      let headerObj = menuHeaderOptions.find((h) => h._id === headermenuId);
      if (!headerObj) {
        headerObj = { _id: headermenuId }; // fallback if full object not available
      }
      if (!updatedMenuHeaderData.some((h) => h._id === headermenuId)) {
        updatedMenuHeaderData.push(headerObj);
      }

      // If the permission is header-level (e.g., Dashboard) then menuId equals headermenuId.
      if (menuId === headermenuId) {
        access.forEach((accessId) => {
          updatedSelectedAccesses.push({
            menuId: headermenuId,
            accessId,
          });
        });
      } else {
        // Otherwise, treat the permission as relating to a subheader or a child menu item.
        // First, try to find the subheader in your options.
        let subHeaderObj = menuSubHeaderOptions.find((sh) => sh._id === menuId);
        if (subHeaderObj) {
          // It's a subheader permission.
          if (!updatedSelectedSubHeaders.some((s) => s._id === menuId)) {
            updatedSelectedSubHeaders.push(subHeaderObj);
          }
          access.forEach((accessId) => {
            updatedSelectedAccesses.push({
              subHeaderId: menuId,
              accessId,
              menuId: headermenuId, // parent header id
            });
          });
        }
      }
    });

    // Update states based on computed arrays.
    setSelectedAccesses(updatedSelectedAccesses);
    setSelectedSubHeaders(updatedSelectedSubHeaders);
    setMenuHeaderData(updatedMenuHeaderData);

    // Show the drawer and open the edit modal.
    setEditModal(true);
    setOpen(true);
  };

  const menuHeaderChange = (e, data) => {
    const isChecked = e.target.checked;
    // Identify if this header is Dashboard.
    const isDashboard = data.menuName?.toLowerCase() === "dashboard";

    // Handle Dashboard separately
    if (isDashboard) {
      if (isChecked) {
        setMenuHeaderData((prev) => {
          // Avoid duplicate addition
          if (!prev.some((item) => item._id === data._id)) {
            return [...prev, data];
          }
          return prev;
        });
      } else {
        // For Dashboard, we do not remove it automatically since it doesn't have subheaders/accesses.
        // (If you want a manual uncheck, you can handle it here.)
        setMenuHeaderData((prev) =>
          prev.filter((item) => item._id !== data._id)
        );
      }
      return;
    }

    // For non-Dashboard headers, continue with normal logic.
    const menuSubHeaderArray =
      data && data.subMenus && data.subMenus.length > 0 ? data.subMenus : [];

    // Prevent selection if there are no subheaders/accesses.
    if (menuSubHeaderArray.length === 0) {
      console.log(
        "This header cannot be selected because it has no subheaders or accesses."
      );
      return;
    }

    const subHeaderAccessArray = menuSubHeaderArray.flatMap((subHeader) =>
      subHeader.menuAccess.map((accessId) => ({
        subHeaderId: subHeader._id,
        accessId,
      }))
    );

    if (isChecked && !isDashboard) {
      setMenuHeaderData((prev) => [...prev, data]);
      setSelectedSubHeaders((prev) => [...prev, ...menuSubHeaderArray]);
      setSelectedAccesses((prev) => [...prev, ...subHeaderAccessArray]);
    } else {
      setMenuHeaderData((prev) => prev.filter((item) => item._id !== data._id));
      setSelectedSubHeaders((prev) =>
        prev.filter((subHeader) => subHeader.headerMenu !== data._id)
      );
      setSelectedAccesses((prev) =>
        prev.filter(
          (access) =>
            !subHeaderAccessArray.some(
              (a) =>
                a.subHeaderId === access.subHeaderId &&
                a.accessId === access.accessId
            )
        )
      );
    }
  };

  const menuAccessChange = (e, subHeaderOptions, accessId, subHeaderId) => {
    const isChecked = e.target.checked;

    setSelectedAccesses((prevSelectedAccesses) => {
      const updatedAccesses = isChecked
        ? [...prevSelectedAccesses, { subHeaderId, accessId }]
        : prevSelectedAccesses.filter(
            (access) =>
              !(
                access.accessId === accessId &&
                access.subHeaderId === subHeaderId
              )
          );

      if (isChecked) {
        // When checking, ensure the related subheader is also added.
        setSelectedSubHeaders((prevSelectedSubHeaders) => {
          if (
            !prevSelectedSubHeaders.some(
              (subHeader) => subHeader._id === subHeaderId
            )
          ) {
            const relatedSubHeader =
              subHeaderOptions &&
              [subHeaderOptions].find(
                (subHeader) => subHeader._id === subHeaderId
              );
            return [...prevSelectedSubHeaders, relatedSubHeader];
          }
          return prevSelectedSubHeaders;
        });

        // Ensure the main header is checked.
        const relatedHeaderId =
          subHeaderOptions &&
          [subHeaderOptions].find((subHeader) => subHeader._id === subHeaderId)
            ?.headerMenu;
        if (
          relatedHeaderId &&
          !menuHeaderData.some((item) => item._id === relatedHeaderId)
        ) {
          const headerToAdd = menuHeaderOptions.find(
            (item) => item._id === relatedHeaderId
          );
          if (headerToAdd) {
            setMenuHeaderData((prev) => [...prev, headerToAdd]);
          }
        }
      } else {
        // When unchecking, remove the subheader if no accesses remain for it.
        if (
          !updatedAccesses.some((access) => access.subHeaderId === subHeaderId)
        ) {
          setSelectedSubHeaders((prevSelectedSubHeaders) =>
            prevSelectedSubHeaders.filter(
              (subHeader) => subHeader._id !== subHeaderId
            )
          );
        }

        // Determine the header that contains this subheader.
        const relatedHeaderId = subHeaderOptions && [subHeaderOptions].find(
          (subHeader) => subHeader._id === subHeaderId
        )?.headerMenu;

        // Check if any accesses remain among all subheaders for this header.
        const relatedSubHeaders = subHeaderOptions && [subHeaderOptions].filter(
          (subHeader) => subHeader.headerMenu === relatedHeaderId
        );
        const allAccessesRelatedToHeaderDeselected = !relatedSubHeaders.some(
          (subHeader) =>
            updatedAccesses.some(
              (access) => access.subHeaderId === subHeader._id
            )
        );

        if (allAccessesRelatedToHeaderDeselected) {
          // Look up the header.
          const headerToRemove = menuHeaderOptions.find(
            (h) => h._id === relatedHeaderId
          );
          // Only remove if it's not Dashboard.
          if (
            headerToRemove &&
            headerToRemove.menuName?.toLowerCase() !== "dashboard"
          ) {
            setMenuHeaderData((prev) =>
              prev.filter((item) => item._id !== relatedHeaderId)
            );
          }
        }
      }

      return updatedAccesses;
    });
  };

  const menuSubHeaderChange = (e, subHeader) => {
    const isChecked = e.target.checked;
    const relatedHeaderId = subHeader.headerMenu;

    if (isChecked) {
      setSelectedSubHeaders((prevSelected) => [...prevSelected, subHeader]);
      const subHeaderAccesses = subHeader.menuAccess.map((accessId) => ({
        subHeaderId: subHeader._id,
        accessId,
      }));
      setSelectedAccesses((prevAccesses) => [
        ...prevAccesses,
        ...subHeaderAccesses,
      ]);
      // const relatedMenuItems = menuItemFilterOptions.filter(
      //   (item) => item.headerMenu === subHeader._id
      // );
      // setMenuItemsData((prev) => [...prev, ...relatedMenuItems]);
      // const relatedAccesses = relatedMenuItems.flatMap((item) =>
      //   item.access.map((accessId) => ({ menuItemId: item._id, accessId }))
      // );
      // setMenuItemsAccessData((prev) => [...prev, ...relatedAccesses]);

      // Ensure the parent header is added.
      setMenuHeaderData((prev) => {
        if (!prev.some((header) => header._id === relatedHeaderId)) {
          const headerToAdd = menuHeaderOptions.find(
            (header) => header._id === relatedHeaderId
          );
          return headerToAdd ? [...prev, headerToAdd] : prev;
        }
        return prev;
      });
    } else {
      setSelectedSubHeaders((prevSelected) =>
        prevSelected.filter((item) => item._id !== subHeader._id)
      );
      const subHeaderAccesses = subHeader.menuAccess.map((accessId) => ({
        subHeaderId: subHeader._id,
        accessId,
      }));
      setSelectedAccesses((prevAccesses) =>
        prevAccesses.filter(
          (access) =>
            !subHeaderAccesses.some(
              (a) =>
                a.accessId === access.accessId &&
                a.subHeaderId === access.subHeaderId
            )
        )
      );
      // const relatedMenuItems = menuItemFilterOptions.filter(
      //   (item) => item.headerMenu === subHeader._id
      // );
      // setMenuItemsData((prev) =>
      //   prev.filter((item) => !relatedMenuItems.includes(item))
      // );
      // setMenuItemsAccessData((prev) =>
      //   prev.filter(
      //     (access) =>
      //       !relatedMenuItems.some((item) => access.menuItemId === item._id)
      //   )
      // );
      // Do not remove the parent header here if it is Dashboard.
      const headerToCheck = menuHeaderOptions.find(
        (h) => h._id === relatedHeaderId
      );
      if (
        headerToCheck &&
        headerToCheck.menuName?.toLowerCase() === "dashboard"
      ) {
        // Skip header removal.
        return;
      }
    }
  };

  useEffect(() => {
    setMenuHeaderData((prevHeaders) =>
      prevHeaders.filter((header) => {
        if (header.menuName?.toLowerCase() === "dashboard") {
          return true;
        }
        const relatedSubHeaders =
          header && header.subMenus && header.subMenus.length > 0
            ? header.subMenus
            : [];
        const isAnySubHeaderSelected = relatedSubHeaders.some((sh) =>
          selectedSubHeaders.some((sel) => sel._id === sh._id)
        );
        const isAnyAccessSelected = relatedSubHeaders.some((sh) =>
          selectedAccesses.some((access) => access.subHeaderId === sh._id)
        );
        return isAnySubHeaderSelected || isAnyAccessSelected;
      })
    );
  }, [selectedSubHeaders, selectedAccesses]);

  //paginations
  const handlePagination = (page, pageSize) => {
    const filter = {
      page: page,
      limit: pageSize,
      status:  "",
      fromDate:"",
      toDate: "",
    };

    const searchFilterValues = Object.keys(filter).forEach(
      (data) => !filter[data] && delete filter[data]
    );
    console.log(searchFilterValues, "searchFilterValues");
//    setPageValue({ page: page, pageSize: pageSize });
    dispatch(loadAccessList(filter));
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  //search , print and download
  const [search, setSearch] = useState("");

  const handleSearch = (event) => {
    const filteredRows = userRoleDataTable.filter(
      (row) =>
        Object.values(row).some((data) =>
          String(data).toLowerCase().includes(event.target.value.toLowerCase())
        )
      // row.productName.toLowerCase().includes(event.target.value.toLowerCase())
    );

    setSearch(event.target.value);
    setUserRoleRows(filteredRows);
    setTableLoading(true);
    setTimeout(() => {
      setTableLoading(false);
    }, 2000);
  };

  const addUserRole = (e) => {
    e.preventDefault();

    if (simpleValidator.current.allValid() && !userRoleData) {
      console.log("Validation failed");
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
      return;
    }
    if (simpleValidator.current.allValid()) {
      const userRoleList = {
        roleId: userRoleName && userRoleName.value,
        // shortCode: userRoleData.shortCode,
        description: description,
        // mode: mode,
        // userId,
        menuDetails: permission,
        // permission: permission,

        // roleId: "678a64a2e2c6362da53e6e56",
        // description: "Dev",
        // menuDetails: [
        //   {
        //     menuId: "68873ffec187ecc88cb779a8",
        //     accessIds: ["68879a9c21f5112d2be05832", "66c88703f4eec74eb828962f"],
        //     canView: true,
        //     canAdd: false,
        //     canEdit: false,
        //     canDelete: false,
        //   },
        // ],
      };

      api
        .post("/masters/adduserpermission", userRoleList)
        .then((res) => {
          setOpen(false);
          toast.success("Records Added Successfully");
          dispatch(loadUserPermissionList());
        })
        .catch((error) => {
          const errorMsg =
            error?.response?.data?.message?.message || "Failed to add records";
          toast.error(errorMsg);
          setOpen(false);
        });
    } else {
      console.log("Validation failed");
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
    }
  };
  const updateUserRole = (e) => {
    e.preventDefault();

    if (simpleValidator.current.allValid() && !userRoleData) {
      console.log("Validation failed");
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
      return;
    }
    if (simpleValidator.current.allValid()) {
      const userRoleList = {
        permissionId: userRoleId,
        roleId: userRoleName && userRoleName.value,
        // shortCode: userRoleData.shortCode,
        description: description,
        // mode: mode,
        // userId,
        menuDetails: permission,
        // permission: permission,

        // roleId: "678a64a2e2c6362da53e6e56",
        // description: "Dev",
        // menuDetails: [
        //   {
        //     menuId: "68873ffec187ecc88cb779a8",
        //     accessIds: ["68879a9c21f5112d2be05832", "66c88703f4eec74eb828962f"],
        //     canView: true,
        //     canAdd: false,
        //     canEdit: false,
        //     canDelete: false,
        //   },
        // ],
      };

      api
        .post("/masters/updateuserpermission", userRoleList)
        .then((res) => {
          setOpen(false);
          toast.success("Records updated successfully");
          dispatch(loadUserPermissionList());
        })
        .catch((error) => {
          const errorMsg =
            error?.response?.data?.message?.message || "Failed to add records";
          toast.error(errorMsg);
          setOpen(false);
        });
    } else {
      console.log("Validation failed");
      simpleValidator.current.showMessages();
      forceUpdate(1);
      setOpen(true);
    }
  };

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>User Permission | Mbook</title>
        </MetaTags>
      </div>

      <Row className="border-solid rounded-sm bg-[#ffffff]">
        <Col span={24}>
          <div className="font-poppins border border-b-1 border-x-0 border-t-0 pl-[20px] pr-[20px] mt-2 pb-2">
            <div className="flex">
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[16px] font-semibold"
              >
                User Permission
              </h1>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="w-[100%] mt-2">
        {/* print, download section */}
        <Col
          md={24}
          lg={24}
          sm={24}
          xs={24}
          className={
            windowDimensions.height > 700 &&
            windowDimensions.height < 830 &&
            userRoleDataTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                userRoleDataTable.length > 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                userRoleDataTable.length == 0
              ? "mt-[1px] h-[80%] bg-[#ffffff] rounded-md"
              : windowDimensions.height > 830 &&
                windowDimensions.height < 1000 &&
                userRoleDataTable.length == 0
              ? "mt-[1px] h-[62vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000 && userRoleDataTable.length == 0
              ? "mt-[1px] h-[73vh] bg-[#ffffff] rounded-md"
              : windowDimensions.height >= 1000
              ? "mt-[1px] h-[82%] bg-[#ffffff] rounded-md"
              : "bg-[#ffffff] h-[72vh] rounded-md"
          }
        >
          <Row className="flex flex-col">
            {/* <Col md={24} lg={24} sm={24} xs={24} className="mt-4 mb-3">
              
            </Col> */}
            <Col md={24} lg={24} sm={24} xs={24} className="mt-5 mb-3">
              <Row className="flex justify-between">
                <Col
                  md={10}
                  lg={10}
                  sm={24}
                  xs={24}
                  className="pr-3 lg:pr-0 md:pr-0 pl-4"
                >
                  {loading ? (
                    <Skeleton.Input
                      style={{
                        minWidth:
                          media === "xxl"
                            ? "185%"
                            : media == "sm" || media == "xs"
                            ? "255%"
                            : "125%",
                        height: "35px",
                      }}
                    ></Skeleton.Input>
                  ) : (
                    <div
                      className={
                        media === "sm" || media === "xs"
                          ? "w-[59%]"
                          : "w-[100%] lg:w-[65%] md:w-[65%]"
                      }
                    >
                      <AutoComplete
                        style={{
                          marginRight: "10px",
                          fontSize: "11px",
                        }}
                        // onClick={() => setSearchOpen(false)}
                        className="w-[100%]"
                      >
                        <Input.Search
                          size="middle"
                          placeholder="Search role"
                          style={{
                            fontFamily: "Poppins",
                            // minHeight: "35px",
                            // border: "1px solid lightgray",
                            fontSize: "11px",
                          }}
                          className="rounded-sm"
                          // bordered={false}
                          name="search"
                          value={search}
                          onChange={(e) => handleSearch(e)}
                        />
                      </AutoComplete>
                    </div>
                  )}
                </Col>
                <Col md={14} lg={14} sm={24} xs={24} className="pr-5">
                  <Row className="flex justify-end">
                    {/* <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="pr-3 sm:pr-3 ml-3 sm:ml-3 mt-3 lg:mt-0 md:mt-0 lg:ml-10 md:ml-10"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                ? "245%"
                                : "125%",
                            paddingRight: media == "md" ? "20px" : "14px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "10px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={14}
                            xs={14}
                            onClick={handleDownloadPDF}
                            className={
                              media == "sm" || media == "xs"
                                ? "cursor-pointer flex justify-center border pt-[5px] pb-[5px] ml-4 mr-4 rounded-sm border-1"
                                : // ? "cursor-pointer border pt-[5px] pb-[5px] ml-3 mr-2 rounded-sm border-1"
                                  "cursor-pointer flex justify-center border pt-[5px] pb-[5px] rounded-sm border-1"
                            }
                            style={{
                              fontFamily: "Poppins",
                            }}
                          >
                            {downloadLoading ? (
                              <p className="flex justify-center">
                                {" "}
                                <Spin className="mr-2" /> Downloading
                              </p>
                            ) : (
                              <p className="flex">
                                <DownloadOutlined className="text-[16px] mr-3" />{" "}
                                Download
                              </p>
                            )}
                          </Col>
                        </Row>
                      )}
                    </Col> */}
                    <Col
                      md={7}
                      lg={7}
                      sm={24}
                      xs={24}
                      className="mt-1 lg:mt-0 md:mt-0"
                    >
                      {loading ? (
                        <Skeleton.Input
                          style={{
                            minWidth:
                              media === "xxl"
                                ? "185%"
                                : media == "sm" || media == "xs"
                                ? "245%"
                                : "125%",
                            paddingRight: media == "md" ? "20px" : "20px",
                            height: "35px",
                            marginLeft:
                              media == "sm" || media == "xs" ? "10px" : "",
                          }}
                        ></Skeleton.Input>
                      ) : (
                        <Row>
                          <Col
                            md={24}
                            lg={24}
                            sm={14}
                            xs={14}
                            className="sm:pr-0 pr-3 ml-3 mt-1 lg:mt-0 xl:mt-0 xxl:mt-0 md:mt-0 xl:ml-0 xxl:ml-0 lg:ml-0 md:ml-0"
                          >
                            <div
                              onClick={() => {
                                setOpen(true);
                                setEditModal(false);
                                setUserRoleName([]);
                                setDescription("");
                              }}
                              className="sm:flex sm:justify-center bg-[#074179] text-[white] focus:bg-[#1d3b59] cursor-pointer px-4 lg:px-7 xl:px-7 xxl:px-5 md:px-2 py-[6px] flex rounded-md hover:bg-[#1d3b59]"
                            >
                              <PlusOutlined className="mr-1" />
                              <h1
                                style={{
                                  fontFamily: "Poppins",
                                }}
                                className="text-[14px] text-[white]"
                              >
                                User Role
                              </h1>
                            </div>
                          </Col>
                        </Row>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Drawer
              closable={false} // hide default X icon
              title={
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <h1 style={{ fontWeight: 600, fontFamily: "Poppins" }}>
                    {editModal ? "Update User Role" : "Add User Role"}
                  </h1>
                  <Button
                    type="text"
                    onClick={onClose}
                    className="font-label"
                    icon={<CloseOutlined />}
                  />
                </div>
              }
              placement="right"
              onClose={onClose}
              open={open}
              width={"100%"}
              maskClosable={false}
              className="font-label"
              styles={{
                body: {
                  padding: "18px",
                },
                footer: {
                  position: "sticky",
                  bottom: 0,
                  background: "#fff",
                  zIndex: 1,
                },
                content: {
                  transition: "transform 1s ease-in-out", // optional, for smoother feel
                },
              }}
              footer={
                <div style={{ textAlign: "right", padding: "4px" }}>
                  <Space>
                    <Button
                      onClick={onClose}
                      style={{
                        background: "#fff1f0",
                        color: "#ff4d4f",
                        borderColor: "#ffa39e",
                      }}
                      className="font-label"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="font-label"
                      type="primary"
                      onClick={editModal ? updateUserRole : addUserRole}
                    >
                      {editModal ? "Update" : "Submit"}
                    </Button>
                  </Space>
                </div>
              }
            >
              <Row>
                <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                  <Row>
                    <Col
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      sm={24}
                      xs={24}
                      className="mb-2"
                    >
                      <Typography className="font-label text-[13px] mb-2">
                        User Role Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                      <Select
                        value={userRoleName}
                        onChange={(newValue, options) =>
                          setUserRoleName({
                            label: options.label,
                            value: newValue,
                          })
                        }
                        placeholder="Select user role"
                        // mode="multiple"
                        options={userRoleOptions}
                        showSearch
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          (option?.label ?? "")
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        className={
                          media == "sm"
                            ? "w-[350px] font-label h-[40px] mt-2"
                            : media == "xs"
                            ? "w-[230px] font-label h-[40px] mt-2"
                            : "w-[100%] font-label h-[40px]"
                        }
                        rootClassName="purchase-label"
                      />
                    </Col>
                  </Row>
                </Col>
                {/* <Col md={24} lg={24} xl={24} xxl={24} sm={24} xs={24}>
                  <Row>
                    <Col
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      xs={24}
                      sm={24}
                      className="mb-3"
                    >
                      <Typography className="font-label mb-2">Mode</Typography>
                      <Radio.Group
                        value={mode}
                        onChange={(e) => setMode(e.target.value)}
                      >
                        <Radio className="font-label" value={"primary"}>
                          Primary User
                        </Radio>
                        <Radio className="font-label" value={"secondary"}>
                          Secondary User
                        </Radio>
                      </Radio.Group>
                    </Col>
                  </Row>
                </Col> */}
                <Col md={12} lg={12} xl={12} xxl={12} sm={24} xs={24}>
                  <Row>
                    <Col
                      md={24}
                      sm={24}
                      lg={24}
                      xl={24}
                      xxl={24}
                      xs={24}
                      className="mb-2"
                    >
                      <Typography className="font-label text-[13px] mb-2">
                        Description
                      </Typography>
                      <Input.TextArea
                        placeholder="Enter Description"
                        value={description}
                        className="font-label mb-2"
                        onChange={(e) => setDescription(e.target.value)}
                        rows={4}
                      />
                    </Col>
                  </Row>
                </Col>

                {/* <Col span={24}>
                  <Checkbox
                    checked={isDefault}
                    onChange={(e) => setIsDefault(e.target.checked)}
                    className="font-label"
                  >
                    Is Default
                  </Checkbox>
                </Col> */}
                <Col span={24} className="mt-3">
                  <Typography className="font-label font-semibold text-[14px] mb-2">
                    Permission
                  </Typography>
                  {(menuHeaderOptions || []).map((data, index) => {
                    const menuAccessList =
                      data && data.subMenus.length > 0 ? data.subMenus : [];

                    const isChecked = menuHeaderData.some(
                      (item) => item._id === data._id
                    );

                    // const editCheck = selectedAccesses.some(
                    //   (item) => item.menuId === data._id
                    // );

                    // const checking = editModal ? editCheck : isChecked;
                    // const hasContent =
                    //   menuSubHeaderOptions.some(
                    //     (sh) => sh.headerMenu === data._id
                    //   ) ||
                    //   menuItemFilterOptions.some((mi) =>
                    //     menuSubHeaderOptions.some(
                    //       (sh) =>
                    //         sh.headerMenu === data._id &&
                    //         mi.headerMenu === sh._id
                    //     )
                    //   );

                    return (
                      <Card
                        style={{ padding: 0, marginBottom: "20px" }}
                        variant="outlined"
                        key={data._id}
                      >
                        <div
                          style={{
                            background: "#e7efef",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            padding: "8px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Checkbox
                              value={menuHeaderData}
                              onChange={(e) => menuHeaderChange(e, data)}
                              checked={isChecked}
                              color="primary"
                              icon={<BiCheckbox fontSize="small" />}
                              checkedIcon={
                                <BiCheckboxChecked fontSize="small" />
                              }
                              // disabled={!hasContent}
                              name="checkedsmall"
                            />
                            <Typography
                              style={{
                                fontSize: "14px",
                                marginTop: "4px",
                                marginLeft: "8px",
                                fontWeight: 600,
                              }}
                              className="font-label"
                            >
                              {data.menuName}
                            </Typography>
                          </div>
                          {menuAccessList.length > 0 ? (
                            <div
                              onClick={() => {
                                setExpandRowOpen(!expandRowOpen);
                                setExpandRowId(data._id);
                              }}
                              style={{
                                marginTop: "7px",
                              }}
                            >
                              {expandRowOpen && data._id == expandRowId ? (
                                <UpOutlined
                                  sx={{
                                    minWidth: "36px",
                                    height: "18px",
                                    padding: "5px 0px",
                                    color: "inherit",
                                  }}
                                  style={{
                                    fontSize: "14px",
                                    cursor: "pointer",
                                  }}
                                />
                              ) : (
                                <DownOutlined
                                  sx={{
                                    minWidth: "36px",
                                    height: "18px",
                                    p: "5px 0px",
                                    color: "inherit",
                                  }}
                                  style={{
                                    fontSize: "14px",
                                    cursor: "pointer",
                                  }}
                                />
                              )}

                              {/* <IconArrowDown /> */}
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <Divider />
                        {/* //Menu Sub Header */}

                        <Collapse
                          in={expandRowOpen && data._id == expandRowId}
                          style={{ marginLeft: "15px" }}
                          timeout="auto"
                          unmountOnExit
                        >
                          <Col
                            xs={24}
                            lg={24}
                            md={24}
                            sm={24}
                            xl={24}
                            xxl={24}
                            className="p-2"
                          >
                            <Row>
                              <Col xs={8} lg={8} md={8} sm={8} xl={8} xxl={8}>
                                <div></div>
                              </Col>
                              <Col xs={16} lg={16} md={16} sm={16} xl={16}>
                                <Row className="flex flex-row w-[100%]">
                                  {accessList.map((access) => {
                                    return (
                                      <Col
                                        xs={4}
                                        lg={4}
                                        md={4}
                                        sm={4}
                                        xl={4}
                                        className="font-label item-1 pr-8"
                                        style={{
                                          textTransform: "capitalize",
                                        }}
                                        key={access._id}
                                      >
                                        {access?.accessName}
                                      </Col>
                                    );
                                  })}
                                </Row>
                              </Col>
                            </Row>
                          </Col>
                          <Divider
                            style={{
                              width: "104%",
                              marginLeft: "-20px",
                            }}
                          />
                          {/* {Sub Header} */}

                          {menuAccessList.length > 0
                            ? menuAccessList.map((subHeader, index) => {
                                const accessNames =
                                  getAccessNamesForMenu(subHeader);
                                const hasAccess = accessNames.length > 0;
                                // const
                                return (
                                  <Col
                                    xs={24}
                                    lg={24}
                                    md={24}
                                    sm={24}
                                    xl={24}
                                    style={{
                                      padding: "8px 4px",
                                    }}
                                    key={subHeader._id}
                                  >
                                    <Row className="w-[100%]">
                                      <Col
                                        xs={8}
                                        lg={8}
                                        md={8}
                                        sm={8}
                                        xl={8}
                                        xxl={8}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <Checkbox
                                        //  value={menuSubHeaderData}
                                          checked={selectedSubHeaders.some(
                                            (item) => item._id === subHeader._id
                                          )}
                                          onChange={(e) =>
                                            menuSubHeaderChange(e, subHeader)
                                          }
                                          color="primary"
                                          icon={<BiCheckbox fontSize="small" />}
                                          checkedIcon={
                                            <BiCheckboxChecked fontSize="small" />
                                          }
                                          name="checkedsmall"
                                          disabled={!hasAccess}
                                        />
                                        <Typography
                                          style={{
                                            fontSize: "14px",
                                            marginTop: "4px",
                                            marginLeft: "4px",
                                            fontWeight: 600,
                                          }}
                                          className="font-label"
                                        >
                                          {subHeader.menuName}
                                        </Typography>
                                      </Col>
                                      {subHeader.menuAccess &&
                                      subHeader.menuAccess.length > 0 ? (
                                        <Col
                                          xs={16}
                                          lg={16}
                                          md={16}
                                          sm={16}
                                          xl={16}
                                          xxl={16}
                                        >
                                          <Row>
                                            {subHeader.menuAccess.length > 0
                                              ? subHeader.menuAccess.map(
                                                  (
                                                    subMenuAccessId,
                                                    index,
                                                    accessId
                                                  ) => {
                                                    const accessListArray =
                                                      accessList.find(
                                                        (data) =>
                                                          data._id ===
                                                          subMenuAccessId.accessId
                                                      );
                                                    if (!accessListArray)
                                                      return null;

                                                    const isChecked =
                                                      selectedAccesses.some(
                                                        (access) =>
                                                          access.accessId && access.accessId.accessId ===
                                                            subMenuAccessId.accessId &&
                                                          access.subHeaderId ===
                                                            subHeader._id
                                                      );
                                                    // const editCheck =
                                                    //   selectedAccesses.some(
                                                    //     (access) =>
                                                    //       access.accessId ===
                                                    //         subMenuAccessId.accessId &&
                                                    //       access.menuId ===
                                                    //         subHeader.headerMenu
                                                    //   );
                                                    // const checking = editModal
                                                    //   ? editCheck
                                                    //   : isChecked;
                                                    // const isSubHeaderSelected =
                                                    //   selectedSubHeaders.some(
                                                    //     (selected) =>
                                                    //       selected._id ===
                                                    //       subHeader._id
                                                    //   );
                                                    // const access =
                                                    //   subHeader.access;

                                                    return (
                                                      <Col
                                                        xs={4}
                                                        lg={4}
                                                        md={4}
                                                        sm={4}
                                                        xl={4}
                                                        xxl={4}
                                                        key={
                                                          accessListArray._id
                                                        }
                                                        style={{
                                                          display: "flex",
                                                          flexDirection: "row",
                                                          width: "100px",
                                                        }}
                                                      >
                                                        <Checkbox
                                                          size="small"
                                                          name={`${accessListArray?.accessName}`}
                                                          // disabled={!isSubHeaderSelected}
                                                          checked={isChecked}
                                                          className="mt-1 ml-2"
                                                          onChange={(e) =>
                                                            menuAccessChange(
                                                              e,
                                                              subHeader,
                                                              subMenuAccessId,
                                                              subHeader._id
                                                            )
                                                          }

                                                          // style={{ fontSize: '10px' }}
                                                        />
                                                        {/* <p className="font-label text-[12px]">
                                                          {
                                                            accessListArray?.accessName
                                                          }
                                                        </p> */}
                                                      </Col>
                                                    );
                                                  }
                                                )
                                              : ""}
                                          </Row>
                                        </Col>
                                      ) : (
                                        <Col
                                          xs={16}
                                          lg={16}
                                          md={16}
                                          sm={16}
                                          xl={16}
                                          xxl={16}
                                          style={{
                                            display: "flex",
                                            flexDirection: "row",
                                          }}
                                        ></Col>
                                      )}
                                    </Row>
                                  </Col>
                                );
                              })
                            : []}
                        </Collapse>
                        {/* </CardContent> */}
                      </Card>
                    );
                  })}
                </Col>
              </Row>
            </Drawer>

            <Col
              span={24}
              className={media === "xxl" ? "pt-2 pl-4 pb-4" : "pr-1 pl-4 pb-4"}
            >
              <Table
                style={{
                  overflow: "hidden",
                }}
                bordered
                columns={HeaderData}
                dataSource={
                  userRoleRows &&
                  userRoleRows.length > 0 &&
                  !isEmpty(userRoleRows[0]._id)
                    ? userRoleRows
                    : []
                }
                rowClassName={"table-row-label p-0"}
                expandable={{
                  // expandedRowRender: expandedRowRender,
                  defaultExpandAllRows: false,
                  // expandIconColumnIndex: 5,
                }}
                pagination={{
                  defaultPageSize: 10,
                  showSizeChanger: true,
                  onShowSizeChange: (e) => console.log(e, "page limit"),
                  pageSizeOptions: ["5", "10", "20", "30"],
                  onChange: (page, pageSize) =>
                    handlePagination(page, pageSize),
                  // page
                  total: !isEmpty(search)
                    ? userRoleRows.length
                    : user_permission_list && user_permission_list
                    ? user_permission_list.total
                    : "",
                  showTotal: (total, pageSize) => {
                    const indexOfLastRow =
                      pageSize && pageSize.length > 0 && pageSize[1];
                    const indexOfFirstRow =
                      pageSize && pageSize.length > 0 && pageSize[0];

                    return (
                      <p
                        style={{
                          fontFamily: "Poppins",
                          fontSize: "12px",
                        }}
                      >
                        Showing rows {indexOfFirstRow} to {indexOfLastRow} of{" "}
                        {!isEmpty(search)
                          ? userRoleRows.length
                          : user_permission_list &&
                            user_permission_list.pagination
                          ? user_permission_list.pagination.total
                          : total}
                      </p>
                    );
                  },
                }}
                sortDirections={"ascend"}
                loading={tableLoading ? true : false}
                showSorterTooltip={"sorter-icon"}
                scroll={{ x: 825 }}
              />
            </Col>
          </Row>
        </Col>
        <Modal
          open={confirmationModal}
          onOk={() => {
            api
              .post("/masters/deleteuserpermission", {
                permissionId: userRoleId,
              })
              .then((res) => {
                toast.success(`${"User permission deleted successfully"}`);
                dispatch(loadUserPermissionList());
                return res.data;
              })
              .catch((error) => {
                const errorMsg =
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  (error &&
                    error.response &&
                    error.response.data &&
                    error.response.data.error) ||
                  (error && error.message);

                toast.error(errorMsg || "There is an issue while login");
                Promise.reject(error);
              });
            setConfirmationModal(false);
          }}
          closeIcon
          maskClosable={false}
          okText={"Confirm"}
          cancelText={"Cancel"}
          okType="danger"
          // okButtonProps={{
          //   disabled: isButtonDisabled ? true : false,
          // }}
          onCancel={() => setConfirmationModal(false)}
          height={300}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-3">
                <OkBtn />
              </div>
            </div>
          )}
        >
          <div className="text-center w-[100%] p-7">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="font-label text-center text-[16px] font-bold">
              Are you sure you want to delete the Organization?
            </h1>
          </div>
        </Modal>
      </Row>
    </React.Fragment>
  );
};

UserPermissionDetails.propTypes = {
  location: PropTypes.any,
  itemId: PropTypes.any,
  organizationId: PropTypes.any,
  partyName: PropTypes.any,
  ledgerLoading: PropTypes.any,
};

export default UserPermissionDetails;
